import { Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
  selector: '[fake-button]'
})
export class FakeButtonDirective implements OnInit{
  constructor(private element: ElementRef) {
  }
  ngOnInit() {
    if (this.element) this.element.nativeElement.onclick = () => false;
  }
}



// WEBPACK FOOTER //
// ./src/directives/fake-button.directive.ts